import { StateModel } from './state-status.model';

export const INBOX_GLOBAL_FILTER = {
	READY_FOR_REVIEW: {
		label: 'Ready for review',
		filters: {
			searchType: 'ReadyForReview',
			formTypes: ['1004', '1073', '1075', '2055'],
			sortBy: ['priority', 'duedate']
		}
	},
	REVISIONS: {
		label: 'Revisions',
		filters: {
			searchType: 'Revisions',
			formTypes: ['1004', '1073', '1075', '2055'],
			sortBy: ['duedate']
		}
	},
	INNOVATION_REVIEW: {
		label: 'Innovation Review',
		filters: {
			searchType: 'InnovationReview',
			formTypes: ['FREDDIE', 'FNMA'],
			sortBy: ['duedate']
		}
	},
	INNOVATION_REVISION: {
		label: 'Innovation Revision',
		filters: {
			searchType: 'InnovationRevision',
			formTypes: ['FREDDIE', 'FNMA'],
			sortBy: ['duedate']
		}
	}
};
